<ng-container *ngComponentOutlet="layoutComponentClass"></ng-container>
<div class="error-text">{{ errorText }}</div>
